"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var PlayerState_1 = __importStar(require("../constants/PlayerState"));

var PlayerError_1 = __importDefault(require("./PlayerError"));
/**
 * Toggle video playback by loading if ended, playing if paused, or else pausing.
 */


exports.loadOrPlayOrPause = function (controller, playerState, streamInfo, extraLoadOptions, setPlayQueued) {
  if (!PlayerState_1.isPlayerState(playerState)) {
    throw new PlayerError_1["default"]('Invalid playerState in loadOrPlayOrPause');
  }

  if (playerState === PlayerState_1["default"].ENDED) {
    // Load
    if (streamInfo) {
      controller.loadVideo(streamInfo, extraLoadOptions);
    } else {
      throw new PlayerError_1["default"]('Nothing to load in loadOrPlayOrPause', {
        fatal: false
      });
    }
  } else if (PlayerState_1.isPaused(playerState)) {
    // Play

    /*
     * There are three cases that must be handled differently:
     *
     * 1. The stream has not been set (because video urls are being
     *    resolved): setPlayQueued is called to indicate that the video
     *    should autoplay when available.
     *
     * 2. The video player is stopped. This probably means that the video
     *    player is awaiting user interaction before it will load any segments.
     *    We are calling setPlayQueued to indicate that the user indends
     *    to play the video.
     *
     * 3. The stream has been set, but is loading its first segment:
     *    setPlayQueued is called to inform components that the video
     *    will start as soon as the first segment has been downloaded.
     *    The video will not start with autoplay since load has already
     *    been called on Controller, therefore play() is called so that
     *    the backend will start playback when ready.
     *
     * 4. The stream is set and loaded: just use play().
     */
    if (!streamInfo) {
      setPlayQueued();
    } else if (playerState === PlayerState_1["default"].STOPPED) {
      setPlayQueued();
    } else if (playerState === PlayerState_1["default"].LOADING) {
      setPlayQueued();
      controller.play();
    } else {
      controller.play();
    }
  } else {
    // Pause
    controller.pause();
  }
};

exports["default"] = exports.loadOrPlayOrPause;